import { M8DebitDTO } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  idUser: number;
};

export const getNotPaidDebits = async (
  params: Params
): Promise<M8DebitDTO[]> => {
  const fetchURL = getM8AdminURL(
    `getNotPaidDebits?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
};
